import type { RootState } from '../../store'

export const selectReportingTeamId = (state: RootState) =>
  state.reporting.teamId

export const selectReportingSessionId = (state: RootState) =>
  state.reporting.sessionId

export const selectReportingExportConfig = (state: RootState) =>
  state.reporting.exportConfig

export const selectReportingPrintingWholeSession = (state: RootState) =>
  state.reporting.printingWholeSession
